import { Injectable } from '@angular/core';
import {httpResource} from '@angular/common/http';
import {Page} from '../pages.interface';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OurServicesService {

  constructor() { }
  pageContentResource = httpResource<Page>(() => `${environment.apiUrl}/pages/our-services`);
}
